<div class="card mb-4">
  <div class="card-body">
    <ms-payment-history-list
      [filter]="paymentHistoryFilter"
      [orderByInput]="orderBy"
      [viewLocation]="PaymentHistoryListViewLocations.MemberProfilePage"
      [isEntityOwner]="isEntityOwner()"
      (orderByChanged)="onOrderByChanged($event)">
    </ms-payment-history-list>
  </div>
</div>
